import React from "react";
import styled from "styled-components";

import Fold4 from "../components/LandingPageComponents/WeWorkWith/WeWorkWith";
import Fold5 from "../components/LandingPageComponents/Fold5/Fold5";
import Reviews from "../components/Reviews/Reviews";
import HowWork from "../components/HowWork/HowWork";
import Articles from "../components/Articles/Articles";
import Fold1 from "../components/LandingPageComponents/Fold1/Fold1";
import Fold2 from "../components/LandingPageComponents/Fold2/Fold2";
import Fold3 from "../components/LandingPageComponents/Fold3/Fold3";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import { Helmet } from "react-helmet-async";

const LandingPage = () => {
  return (
    <>
      <Helmet>
        <title>
          Digital Product Development for Scale-ups & SMEs | appssemble
        </title>
        <meta
          name="description"
          content="appssemble builds fast, scalable digital products for scale-ups and SMEs. We deliver solutions, not headcounts—trusted by leaders in tech, finance, and media."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="appssemble" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Digital Product Development for Scale-ups & SMEs | appssemble"
        />
        <meta
          property="og:description"
          content="We help growing companies and non-tech businesses build reliable digital products fast. Small teams, big results. See our case studies."
        />
        <meta property="og:url" content="https://appssemble.com" />
        <meta
          property="og:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Digital Product Development for Scale-ups & SMEs | appssemble"
        />
        <meta
          name="twitter:description"
          content="appssemble delivers digital solutions to growing businesses. No headcounts. Just fast, reliable product delivery with accountability."
        />
        <meta
          name="twitter:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        <link rel="canonical" href="https://appssemble.com" />
      </Helmet>
      <Wrapper>
        <Fold1 />
        <Fold2 />
        <Fold3 />
        <Fold4 />
        <Fold5 />
        <Reviews />
        <HowWork />
        <Articles />
        <TrackingComponent />
      </Wrapper>
    </>
  );
};

export default LandingPage;

const Wrapper = styled.div`
  min-height: 100vh;
`;
